import { Box, Card, Typography } from "@mui/material";
import { ReactNode } from "react";

interface Props {
    icon: ReactNode;
    title: string;
    value: string;
}
const DataDisplayCard = ({ icon, title, value }: Props) => {
    const specialBackgroundTitles = ["Conversion Rate", "Won Deals", "Avg Score", "Won leads"];
    const hasSpecialBackground = specialBackgroundTitles.includes(title);

    return (
        <Card
            variant="outlined"
            sx={{
                display: "flex",
                flexDirection: "column",
                padding: "16px",
                borderRadius: "16px",
                width: "100%",
                height: "100%",
                minHeight: "120px",
                backgroundColor: hasSpecialBackground ? "#FEF9F4" : "white",
                justifyContent: "space-between"
            }}
        >
            <Box sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
                height: "40px", // Fixed height for consistent icon positioning
                width: "100%",
                mb:"36px"
            }}>
                {icon}
            </Box>

            <Box sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                flex: 1,
                justifyContent: "flex-end"
            }}>
                <Typography sx={{ marginBottom: "4px", fontWeight: 600, fontSize: "1.5rem" }}>
                    {value}
                </Typography>
                <Typography sx={{ color: "gray", fontSize: "0.875rem" }}>
                    {title}
                </Typography>
            </Box>
        </Card>
    )
}

export default DataDisplayCard;